/**
 * AI assistant drawer header.
 *
 */
/* global define, Marionette */
define( 'views/app/drawer/headerAiAssistant',[], function () {
	const view = Marionette.ItemView.extend( {
		tagName: 'div',
		template: '#tmpl-nf-drawer-header-ai-assistant',
	} );

	return view;
} );

